import { render, staticRenderFns } from "./PoiRegChart.vue?vue&type=template&id=46cca71f"
import script from "./PoiRegChart.vue?vue&type=script&lang=js"
export * from "./PoiRegChart.vue?vue&type=script&lang=js"
import style0 from "./PoiRegChart.vue?vue&type=style&index=0&id=46cca71f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports